import script from "./ListadoNiveles.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoNiveles.vue?vue&type=script&setup=true&lang=js"

import "./ListadoNiveles.vue?vue&type=style&index=0&id=011abca8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-011abca8"]])

export default __exports__